<template>
  <div :class="$style.nav">
    <div
      v-for="cat of categories"
      :class="[$style.item, activeCat === cat.term_id && $style.active]"
      @click="emits('updateValue', cat.term_id)"
    >
      {{ cat?.name }}

      <UiIconsArrowRight />
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
interface NavigationParams {
  categories: Record<any, any>[] | null,
  activeCat: string,
}

defineProps<NavigationParams>();
const emits = defineEmits(['updateValue']);
</script>

<style lang="scss" module>
  .nav {
    display: flex;
    flex-direction: column;
    gap: 14px;

    @media (max-width: 767px) {
      flex-direction: row;
      gap: 6px;
      text-align: center;
    }
  }

  .item {
    display: flex;
    align-items: center;
    gap: 16px;
    width: 251px;
    padding: 16px 19px 15px 36px;
    border-radius: 25.5px;
    background-color: #F8F8F8;
    color: #121E29;
    transition: 200ms ease;
    cursor: pointer;

    @media (max-width: 767px) {
      justify-content: center;
      padding: 16px 19px 15px 19px;
    }

    svg {
      flex-shrink: 0;
      width: 11px;
      height: auto;
      margin-left: auto;
      transition: 200ms ease;
      opacity: 0;

      @media (max-width: 767px) {
        display: none;
      }
    }

    &.active {
      background-color: #293EFF;
      color: #fff;

      svg {
        opacity: 1;
      }
    }
  }
</style>